// extracted by mini-css-extract-plugin
export default {"fetching":"Components_fetching__2Tg9j","components":"Components_components__1AnM-","component":"Components_component__2ARo6","contentWrapped":"Components_contentWrapped__g4wJi"};